"use strict";

var uniqueByL = require("../Lazy/uniqueByL.js");

var entriesL = require('../Lazy/entriesL.js');

var curry = require('./curry.js');

var isIterable = require('./isIterable.js');

var object = require('./object.js');

var takeAll = require("./takeAll.js");

var last = require('./last.js');

module.exports = curry(function uniqueBy(f, iter) {
  return isIterable(iter) ? takeAll(uniqueByL(f, iter)) : object(uniqueByL(e => f(last(e)), entriesL(iter)));
});